export default __webpack_public_path__ + "static/media/java-not-found.ae7ab92a.png";